export default __webpack_public_path__ + "static/media/Lock 1.8849af81.svg";